"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backgroundScreenFactory = void 0;
const Factory = require("factory.ts");
const util_1 = require("../../util");
const statuses = [
    'passed',
    'failed',
    'error',
    'flagged',
    'pending',
    'incomplete',
    'cancelled',
    'closed',
    'pending_verification',
    'duplicate'
];
exports.backgroundScreenFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    persona_id: 1,
    status: Factory.each(i => util_1.rand(statuses)),
    status_updated_at: (new Date()).toISOString(),
    survey_id: 12,
    survey_result_id: 14
});
